/*
 * @Description:
 * @Author: JDY
 * @Date: 2021-05-08 14:21:23
 * @LastEditTime: 2021-05-08 14:36:58
 * @LastEditors: JDY
 */
import { requestDelete, requestGet } from '@/api/api'

const list = {
    data () {
        return {
            loading: false,
            treeData: []
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-27 11:10:20
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:整理目录树数据
         * @param  {*}
         * @return {*} 返回数据
         * @param {*} data 每级数据
         * @param {*} pid 父级ID
         */
         trimTreeLists (data, pid) {
            data.filter(item => {
                item.scopedSlots = { title: 'custom' }
                item.tree_id = pid
                if (item.children) {
                    this.trimTreeLists(item.children, pid + 1)
                }
                return false
            })
            return data
        },
        /**
         * @Author: JDY
         * @Date: 2021-04-27 11:17:21
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:获取目录树列表数据
         * @param  {*}
         * @return {*}
         */
        getTreeLists () {
            this.loading = true
            const { apiList } = this
            requestGet(apiList.getList)
                .then(res => {
                    const { result } = res
                    this.treeData = this.trimTreeLists(result, 0)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        /**
         * 删除
         * @JDY
         * @2020/12/11
         */
        handleTreeDelete (id) {
            this.loading = true
            const { apiList } = this
            requestDelete(apiList.delete + id)
                .then(res => {
                    this.$notification.success({
                        message: res.msg
                    })
                    this.getTreeLists()
                })
                .finally(() => {
                    this.loading = false
                })
        }

    },
    created () {}
}
export default list
